enum GynecologistEnum {
	CLINICAL_GYNECOLOGY = 'GINECOLOGIA CLINICA',
	GYNECOLOGY_AND_OBSTETRICS = 'GINECOLOGIA E OBSTETRICIA',
	GYNECOLOGY_AND_OBSTETRICS_GINECOLOGIST = 'GINECOLOGIA E OBSTETRICIA - GINECOLOGIA',
	PRE_NATAL_OBSTETRICS = 'OBSTETRICIA / PRE NATAL',
	CODE = '451',
}

enum WellBornEndpoints {
	WELL_BORN = 'NASCER BEM',
	CARRY_PREGNANCY_WELL = 'GESTAR BEM',
}

const gynecologyNames = [
	GynecologistEnum.CLINICAL_GYNECOLOGY,
	GynecologistEnum.GYNECOLOGY_AND_OBSTETRICS,
	GynecologistEnum.PRE_NATAL_OBSTETRICS,
	GynecologistEnum.GYNECOLOGY_AND_OBSTETRICS_GINECOLOGIST,
];

export {GynecologistEnum, gynecologyNames, WellBornEndpoints};
